const IST_LOCALE_OPTIONS = {
  day: "numeric",
  month: "long",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  hour12: true,
  timeZone: "Asia/Kolkata",
};

/**
 * Formats a date/datetime string into a human-readable IST string.
 * Example output: "1 January 2026, 10:30 am"
 */
export const formatDateTime = (date) => {
  if (!date) return "—";
  const d = new Date(date);
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleString("en-IN", IST_LOCALE_OPTIONS);
};

/**
 * Formats a date/datetime string into a human-readable IST string with
 * "at" as the separator between date and time.
 * Example output: "1 January 2026 at 10:30 am"
 */
export const formatDisplayDateTime = (date) => {
  if (!date) return "—";
  const d = new Date(date);
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleString("en-IN", IST_LOCALE_OPTIONS).replace(",", " at");
};

/**
 * Returns the date portion in YYYY-MM-DD format in the IST timezone.
 * Useful for comparing dates without time components.
 */
export const formatDateOnly = (date) => {
  const d = new Date(date);
  return d.toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });
};
